import CookiesBase from 'js-cookie';
var Cookies = CookiesBase.withConverter({
  write: function write(value) {
    return encodeURIComponent(value).replace(/%(23|24|26|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
  },
  read: function read(value) {
    return value.replace(/\+/g, ' ').replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
  }
});
export default Cookies;